import { render } from "./ed-organism-card-block.vue?vue&type=template&id=dcc5a81e"
import script from "./ed-organism-card-block.vue?vue&type=script&lang=js"
export * from "./ed-organism-card-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__